commusoftCommon.filter('compressCommas', function() {
    return function (value) {
        if (typeof value === 'object' && value !== null) {
            value = Object.values(value).filter(v => v !== '').join(', ');
        } else {
            var find = ', ,';
            while (value.indexOf(find) != -1) {
                value = value.replace(new RegExp(find, 'g'), ',');
            }
        }
        return value;
    };
});
